import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject } from 'rxjs';
import { Platform, ToastController, NavController } from '@ionic/angular';
import { IonicComponentesService } from '../components/ionic-componentes.service';

@Injectable()
export class AutenticacionService {

  authState = new BehaviorSubject(false);
  user: string;
  datastorage: any;
  version: string;

  constructor(
    private router: Router,
    private storage: Storage,
    private platform: Platform,
    public toastCtrl: ToastController,
    private ioniComp: IonicComponentesService,
    private navCtrl: NavController
  ) {
    this.platform.ready().then(() => {
      this.init();

      setTimeout(() => {
        this.ifLoggedIn();
      }, 500);
    });
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    this.storage = await this.storage.create();
  }


  ifLoggedIn() {
    this.storage.get('storage_xxx').then((response) => {
      // if (response) {
      //   this.authState.next(true);
      // }

      if (response) {
        // console.log(state)
        this.authState.next(true);
        this.storage.get('zonaGuard').then((response) => {
          if (response) {
            this.navCtrl.navigateRoot('/tabs');
          }else{
            this.navCtrl.navigateRoot('/zonausuario');
          }
        });

      } else {
        this.navCtrl.navigateRoot('/login');
      }
    });
  }


  login(res) {
    this.storage.set('storage_xxx', res).then((response) => {
      this.ioniComp.presentToast('Acceso correcto');
      this.navCtrl.navigateRoot(['/zonausuario']);
      this.authState.next(true);
    });
  }

  logout() {
    this.storage.remove('storage_xxx').then(() => {
      this.ioniComp.presentToast('Cerrado correctamente');
      this.navCtrl.navigateRoot(['/login']);
      this.authState.next(false);
    });
  }

  setToken(token){
      this.storage.set('tokenAuth', token)
  }

  isAuthenticated() {
    return this.authState.value;
  }

}
